import styled from 'styled-components';
import Colors from 'assets/Colors';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const PhotoWrapper = styled.div`
  border-radius: 50%;
  border: 2px solid ${Colors.text_primary};
  height: 38px;
  width: 38px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
`;

const RightElementsWrapper = styled.div`
  margin-left: 9px;
`;

const NameTextWrapper = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: -0.408px;
  color: ${Colors.text_primary};
`;

const SubNameTextWrapper = styled.div`
  font-style: italic;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  color: ${Colors.text_secondary};
`;

export default {
  Wrapper,
  PhotoWrapper,
  RightElementsWrapper,
  NameTextWrapper,
  SubNameTextWrapper,
};
